import { Component } from '@angular/core';

import { TakeUntilDestroy } from '../../../../common/take-until-destroy.decorator';
import { DataSource } from '../../../backend';
import { currentBuilderState } from '../../builder.state';
import { reset } from '../../function/reset.function';
import { updateRouterQueryParams } from '../../function/update-router-query-params.function';
import { BuilderState } from '../../model/builder-state.model';

@Component({
    selector: 'cmps-report-builder-data-source',
    templateUrl: './data-source.component.html',
})
@TakeUntilDestroy()
export class DataSourceComponent {
    /** @private */
    readonly _DataSource = DataSource;

    /** @private */
    _state: BuilderState;

    constructor() {
        this._state = currentBuilderState();
    }

    /** @private */
    _onChange(value: DataSource): void {
        reset(value);
        updateRouterQueryParams();
    }
}
